var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7393 0C59.3764 0 68 8.62359 68 19.2607V48.7393C68 59.3764 59.3764 68 48.7393 68H19.2607C8.62359 68 0 59.3764 0 48.7393V19.2607C0 8.62359 8.62359 0 19.2607 0H48.7393Z",
    fill: "#FFF5D4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9206_53397)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(15.8618 16)",
    fill: "#FFF5D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7832 22.3656L51.1816 21.3249C50.7613 20.9045 50.1806 20.6446 49.5393 20.6446H49.3984L33.8619 24.226L18.3253 20.6445H18.1844C17.543 20.6445 16.9623 20.9045 16.542 21.3249L16.7759 46.1635L51.5401 46.2118C51.7445 45.866 51.8619 45.4625 51.8619 45.0317V22.9672C51.8619 22.7591 51.8345 22.5575 51.7832 22.3656Z",
    fill: "#FFE596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3252 20.6445L30.9874 33.307C32.5734 34.8916 35.1512 34.8916 36.736 33.307L49.3983 20.6445H18.3252Z",
    fill: "#FFE596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7831 22.3648C51.6768 21.9644 51.4638 21.6096 51.1814 21.3243L37.9676 34.5381C35.7 36.8057 32.0236 36.8057 29.7561 34.5381L16.542 21.3242C16.1198 21.7423 15.8618 22.3243 15.8618 22.9664V45.031C15.8618 46.3137 16.9017 47.3536 18.1844 47.3536H49.5393C50.1387 47.3536 50.704 47.1118 51.1133 46.7375C51.2874 46.5805 51.4197 46.4152 51.5401 46.2111L39.7386 34.4093L51.7831 22.3648ZM17.9324 44.4622C17.7286 44.1167 17.6038 43.719 17.6038 43.2889V26.8316C17.6038 25.797 18.8547 25.2789 19.5863 26.0104L27.9851 34.4092L17.9324 44.4622ZM49.2986 45.6116H19.9263C19.4964 45.6116 19.0988 45.4868 18.7534 45.2831L28.8074 35.229C30.0842 36.4914 31.764 37.3179 33.5583 37.3936C35.532 37.4768 37.4014 36.7465 38.7887 35.3592L38.9175 35.2303L49.2986 45.6116Z",
    fill: "#FFC860"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9206_53397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(15.8618 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.5d8929b50271526df74136cc03b21c9d.svg";
export { ForwardRef as ReactComponent };